import React, { useState, useEffect } from 'react';
import { B } from '../constants';

const COOKIE_KEY = 'greatbreak_cookie_consent';

export default function CookieConsent({ onAccept }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = (essentialOnly = false) => {
    localStorage.setItem(COOKIE_KEY, essentialOnly ? 'essential' : 'all');
    setVisible(false);
    if (onAccept) onAccept(essentialOnly);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      background: 'white',
      boxShadow: '0 -4px 20px rgba(0,0,0,0.15)',
      padding: '20px 24px',
      zIndex: 1000,
      fontFamily: "'Montserrat',sans-serif",
    }}>
      <div style={{ maxWidth: 800, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 16 }}>
        <div style={{ flex: 1, minWidth: 280 }}>
          <h3 style={{ margin: '0 0 8px 0', fontSize: 16, color: B.night }}>🍪 We use cookies</h3>
          <p style={{ margin: 0, fontSize: 13, color: B.muted, lineHeight: 1.5 }}>
            We use cookies to improve your experience and analyze app usage. 
            <span style={{ display: 'block', marginTop: 4 }}> By accepting, you agree to our <a href="/terms" style={{ color: B.forest }}>Terms</a> and <a href="/privacy" style={{ color: B.forest }}>Privacy Policy</a>.</span>
          </p>
        </div>
        
        <div style={{ display: 'flex', gap: 12 }}>
          <button
            onClick={() => handleAccept(true)}
            style={{
              padding: '10px 20px',
              borderRadius: 8,
              border: '1px solid #ddd',
              background: 'white',
              color: B.night,
              cursor: 'pointer',
              fontSize: 13,
              fontWeight: 600,
            }}
          >
            Essential Only
          </button>
          <button
            onClick={() => handleAccept(false)}
            style={{
              padding: '10px 20px',
              borderRadius: 8,
              border: 'none',
              background: B.forest,
              color: 'white',
              cursor: 'pointer',
              fontSize: 13,
              fontWeight: 600,
            }}
          >
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
}